var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommentIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 20 / Comment-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.825 7.08679H11.945M5.825 10.1446H8.885M14.7881 17.0477C14.567 16.9151 14.4564 16.8488 14.3442 16.7897C13.7601 16.482 13.1164 16.3038 12.4571 16.2674C12.3305 16.2604 12.2015 16.2604 11.9437 16.2604H8.885C6.74633 16.2604 5.67699 16.2604 4.83348 15.9112C3.7088 15.4457 2.81525 14.5528 2.34939 13.4289C2 12.5859 2 11.5174 2 9.38018C2 7.24301 2 6.17442 2.34939 5.3315C2.81525 4.20761 3.7088 3.31468 4.83348 2.84915C5.67699 2.5 6.74633 2.5 8.885 2.5H9.956C12.5266 2.5 13.812 2.5 14.7938 2.99993C15.6575 3.43968 16.3597 4.14137 16.7997 5.00443C17.3 5.9856 17.3 7.27002 17.3 9.83886V15.6265C17.3 16.0572 17.3 16.2725 17.268 16.4181C17.0925 17.2182 16.2607 17.6888 15.4839 17.4276C15.3425 17.3801 15.1577 17.2693 14.7881 17.0477Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommentIcon);
export default ForwardRef;